import * as React from "react"
import { Box, Tab, Tabs } from "@mui/material"

export default function TabbedView({ tabNames, tabs }) {
  const [value, setValue] = React.useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <Box>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          mb: 3,
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          {tabNames.map((name, i) => (
            <Tab label={name} key={i} />
          ))}
        </Tabs>
      </Box>
      {tabs.map((content, i) =>
        value === i ? <React.Fragment key={i}>{content}</React.Fragment> : null
      )}
    </Box>
  )
}
